'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('db-admin-list', {
      url: '/db-admin/:collection',
      template: '<db-admin-list></db-admin-list>',
      authenticate: 'superadmin'
    });
}



// WEBPACK FOOTER //
// ./client/~ap/app/superadmin/db/list/db-admin-list.routes.js